import React from 'react';
import { Flex, FlexProps, Icon, Text } from '@qga/roo-ui/components';
import PointsEarnDisplay from 'components/PointsEarnDisplay';
import { POINTS_EARN_ENABLED } from 'config';
import styled from '@emotion/styled';

interface PointsEarnSummaryProps extends FlexProps {
  total: number;
  base?: number;
  fontSize?: string[] | string;
  luxuryInclusions?: boolean;
  topMargin?: number;
}

const PointsBox = styled(Flex)`
  justify-content: start;
  flex-direction: row;
  line-height: tight;
`;

const PointsEarnSummary = ({ total, base, fontSize = 'sm', luxuryInclusions = false, topMargin = 0, ...rest }: PointsEarnSummaryProps) => {
  if (!POINTS_EARN_ENABLED || total <= 0) {
    return null;
  }

  return (
    <PointsBox mt={topMargin} {...rest}>
      {luxuryInclusions && <Icon name="roo" mr="4px" mt="3px" color="brand.primary" size={20} />}
      <Text data-testid="points-earn-summary-text" color="greys.charcoal" fontSize={fontSize} textAlign="end">
        {'Earn '}
        <PointsEarnDisplay total={total} base={base} fontSize={fontSize} fontWeight="bold" />
        <Text color="greys.charcoal" fontSize={fontSize} fontWeight="bold">
          {' PTS^'}
        </Text>
      </Text>
    </PointsBox>
  );
};

export default PointsEarnSummary;
